import { useEffect, useState } from 'react';

import ZpButton from 'components/zpButton';
import { useCtxHistory } from 'hooks';
import { useAppDispatch, useAppSelector } from 'hooks/useRedux';
import { openSignUpModal } from 'store/modals/actions';
import { POPUP_SURVEY_SOURCE } from 'utils/constant';

import StickyFooter from '.';

interface IProps {
  timeoutInSec?: number;
  globalTurnOn?: boolean;
  pageCategories?: string[];
}

const StickyFooterContainer = ({
  timeoutInSec = 10,
  pageCategories = [],
  globalTurnOn = true,
}: IProps) => {
  const [open, setOpen] = useState(false);

  const dispatch = useAppDispatch();

  const history = useCtxHistory();

  const isUserLoggedIn = useAppSelector((state) => !!state.user.isLoggedIn);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    // if no pageCategories then show the sticky footer on all the pages
    const needToShow =
      !isUserLoggedIn && (!pageCategories.length || pageCategories.includes(window.pageCategory));

    if (needToShow && globalTurnOn) {
      timeoutId = setTimeout(() => {
        setOpen(true);
      }, timeoutInSec * 1000);
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [isUserLoggedIn, pageCategories, globalTurnOn]);

  const onResumeUploadClick = () => {
    const routeQuery = {
      survey: '047',
      survey_step: 'step1',
      src: POPUP_SURVEY_SOURCE.STICKY_FOOTER_RESUMES,
    };
    const payload = {
      survey: '047',
      survey_step: 'step1',
      activitySource: `sign_up-${POPUP_SURVEY_SOURCE.STICKY_FOOTER_RESUMES}`,
    };
    // open the survey popup
    dispatch(openSignUpModal({ ...payload }, false));

    // add the query parameter in the url
    history.pushQuery(routeQuery);

    // close the sticky footer
    setOpen(false);
  };

  return (
    <StickyFooter open={open} onClose={() => setOpen(false)} scrollUpAnimation>
      <div className="d-flex justify-content-between justify-content-md-center align-items-center w-100">
        <div className="openSansBlack">Match Your CV to Jobs</div>
        <ZpButton className="ml-0 ml-md-3" onClick={onResumeUploadClick}>
          Upload Your Resume
        </ZpButton>
      </div>
    </StickyFooter>
  );
};

export default StickyFooterContainer;
